<template>
  <!--begin::Portlet-->
  <div class="kt-portlet">
    <div class="kt-portlet__body">
      <div class="row">
        <div class="col-12 col-md-8 order-first order-md-last main-content">
          <h2>Whoops! Looks like this page doesn't exist!</h2>
          <h4>Here are some links that may help you on your way</h4>

          <div class="suggested-routes">
            <a href="javascript:void(0)" class="btn btn-ss" @click="goBack">Go Back</a>
            <a href="/" class="btn btn-ss">Dashboard</a>
            <a v-for="(suggested_route, index) in suggested_routes" :key="index"
               :href="suggested_route.url"
               class="btn btn-ss">
              {{ suggested_route.label }}
            </a>
          </div>
          <div class="other-routes my-4">
            <a href="https://status.sharp-stream.com/" target="_blank">Status Page</a>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <img width="100%" src="/build/media/misc/404_seagull.gif">
        </div>
      </div>
    </div>
  </div>
  <!--end::Portlet-->
</template>

<script>
export default {
  data: () => ({
    suggested_routes: window.suggested_routes,
  }),
  methods: {
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
    .suggested-routes {
        margin-top:1em;
        .btn {
            text-transform: capitalize;
            margin-right:1em;
        }
    }
</style>
